import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, Bot } from 'lucide-angular';
import { StatusBadgeComponent } from '../status-badge/status-badge.component';
import { Chatbot } from '../../../core/models/chatbot.model';

@Component({
  selector: 'app-chatbot-card-grid',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, StatusBadgeComponent],
  template: `
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      @for (chatbot of chatbots; track chatbot.chatbotId) {
        <div
          (click)="selectChatbot.emit(chatbot.chatbotId)"
          class="bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border rounded-2xl p-6 hover:shadow-medium hover:border-light-primary/30 dark:hover:border-dark-primary/30 transition-all duration-200 cursor-pointer group"
        >
          <!-- Bot Avatar -->
          <div class="flex items-center justify-center mb-4">
            <div
              class="w-16 h-16 rounded-2xl flex items-center justify-center shadow-soft group-hover:shadow-medium transition-all duration-200 relative overflow-hidden"
              [ngClass]="avatarStyle === 'gradient' ? 'bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500' : 'bg-gradient-to-br from-light-primary to-light-primary-variant dark:from-dark-primary dark:to-dark-primary-variant'"
            >
              <div class="absolute inset-0 bg-black/10 mix-blend-overlay"></div>
              @if (avatarStyle === 'initial') {
                <lucide-angular
                  [img]="BotIcon"
                  class="w-8 h-8 text-white relative z-10"
                ></lucide-angular>
              } @else {
                <span class="text-white text-2xl font-bold relative z-10">
                  {{ chatbot.name.charAt(0).toUpperCase() }}
                </span>
              }
            </div>
          </div>

          <!-- Bot Info -->
          <div class="text-center mb-4">
            <h3 class="mb-1">{{ chatbot.name }}</h3>
            @if (showCode) {
              <p class="normal mb-2">{{ chatbot.code }}</p>
            }
            <p class="small line-clamp-2" [class.min-h-[40px]]="!showCode">
              {{ chatbot.description }}
            </p>
          </div>

          <!-- Status -->
          <div class="flex items-center justify-center">
            <app-status-badge [isActive]="chatbot.isActive"></app-status-badge>
          </div>
        </div>
      }
    </div>
  `,
})
export class ChatbotCardGridComponent {
  @Input({ required: true }) chatbots!: Chatbot[];
  @Input() avatarStyle: 'initial' | 'gradient' = 'gradient';
  @Input() showCode: boolean = true;
  @Output() selectChatbot = new EventEmitter<number>();

  readonly BotIcon = Bot;
}
